export enum LogInState {
    AppLoading = -1,
    NotLoggedIn,
    LoggedIn
}

export enum Role {
    Unknown = -1,
    User = 1,
    Administrator = 2,
    SuperAdmin = 3
}

export enum ConnectionStatus {
    NoAttempts,
    Connecting,
    Connected,
    TestingToken,
    TokenTested,
    NoConnection
}

export enum DataLoadingStatus {
    NotLoaded,
    Loading,
    IdleLoading,
    Loaded,
    Error
}

export enum AttTestOperator {
    Equals = 1,
    NotEquals = 2,
    In = 3,
    NotIn = 4
}

export enum GroupOperation {
    And = 1,
    Or = 2,
    Xor = 3
}

export enum IndicatorSiblingType {
    NoSibling = 0,
    Indicator = 1,
    Group = 2
}
